import { formatterPx, parsePx } from '@/utils';

export default (selectedObjectProps, t, locale) => {
  return {
    fields: [
      ...(selectedObjectProps.source
        ? [
            {
              as: 'button',
              name: 'cancel-translate',
              text: t('common.particalCancellation'),
              type: 'default',
              size: 'middle',
              guide: {
                img:
                  locale === 'KOR'
                    ? 'https://i.tosoiot.com/statics/cancel-translate-korean.gif'
                    : 'https://i.tosoiot.com/statics/cancel-translate.gif',
                placement: 'bottomRight',
                width: 800,
              },
            },
          ]
        : []),
      {
        as: 'input',
        label: t('propsEditor.originText'),
        labelStyle: { display: 'block', width: '100%' },
        type: 'textarea',
        name: 'source',
        placeholder: t('propsEditor.originTextContent'),
        disabled: false,
        compStyle: { width: '100%' },
        copyable: true,
      },
      {
        as: 'translate',
        label: '',
        labelStyle: { display: 'block', width: '100%' },
        type: 'target',
        name: 'target',
        placeholder: t('propsEditor.translatedTextContent'),
        compStyle: { width: '100%' },
      },
      {
        type: 'group',
        label: t('propsEditor.textStyle'),
        expanded: true,
        labelWidth: '60px',
        children: [
          {
            type: 'inline',
            children: [
              {
                as: 'font-family',
                label: t('propsEditor.fontFamily'),
                name: 'fontFamily',
                compStyle: { width: '168px' },
              },
              {
                as: 'number',
                label: '',
                name: 'fontSize',
                placeholder: t('propsEditor.setFontSize'),
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '68px' },
              },
            ],
          },
          // { as: 'select', label: '字体', name: 'fontFamily', placeholder: '选择字体', compStyle: { width: '180px' } },
          // { as: 'number', label: '行高', name: 'lineHeight', placeholder: '设置行高', compStyle: { width: '180px' } },
          {
            as: 'radio-group',
            label: t('propsEditor.textColorType'),
            name: 'fgType',
            list: [
              { value: 'pure', label: t('propsEditor.fgTypePure') },
              { value: 'gradient', label: t('propsEditor.fgTypeGradient') },
            ],
          },
          {
            as: 'color',
            show: () => selectedObjectProps.fgType === 'pure',
            label: t('propsEditor.textColor'),
            name: 'fg',
          },
          {
            as: 'radio-group',
            show: () => selectedObjectProps.fgType === 'gradient',
            label: t('propsEditor.fgGradientDirection'),
            name: 'fgGradientDirection',
            list: [
              { value: 'h', label: t('propsEditor.horizontal') },
              { value: 'v', label: t('propsEditor.vertical') },
            ],
          },
          {
            type: 'inline',
            children: [
              {
                as: 'color',
                labelStyle: { width: '60px' },
                style: { width: '150px' },
                show: () => selectedObjectProps.fgType === 'gradient',
                label: t('propsEditor.fgGradientStart'),
                name: 'fgGradientStart',
              },
              {
                as: 'color',
                show: () => selectedObjectProps.fgType === 'gradient',
                label: t('propsEditor.fgGradientEnd'),
                name: 'fgGradientEnd',
              },
            ],
          },
          // { as: 'color', label: '阴影颜色', name: 'bg' },
          { as: 'color', label: t('propsEditor.backgroundColor'), name: 'backgroundColor' },
          {
            type: 'inline',
            children: [
              { as: 'align', label: '', name: 'textAlign' },
              { as: 'font-style', label: '', name: 'fontStyle' },
              { as: 'text-case', label: '', name: 'textCase' },
            ],
          },
          {
            as: 'number',
            label: t('common.lineHeight'),
            placeholder: t('common.lineHeight'),
            name: 'lineHeight',
            step: 0.1,
            min: 0.1,
            compStyle: { width: '72px' },
          },
        ],
      },
      {
        type: 'group',
        label: t('propsEditor.strokeSetting'),
        expanded: true,
        labelWidth: '60px',
        children: [
          {
            as: 'slider',
            label: t('propsEditor.strokeWidth'),
            labelBlock: true,
            name: 'strokeWidth',
            compStyle: { width: '230px' },
          },
          { as: 'color', label: t('propsEditor.strokeColor'), name: 'stroke' },
        ],
      },
      {
        type: 'group',
        label: t('propsEditor.shadowSetting'),
        expanded: true,
        labelWidth: '60px',
        children: [
          {
            as: 'slider',
            label: t('propsEditor.shadowRange'),
            labelBlock: true,
            name: 'shadowBlur',
            compStyle: { width: '230px' },
          },
          { as: 'color', label: t('propsEditor.shadowColor'), name: 'bg' },
        ],
      },
      {
        type: 'group',
        label: t('propsEditor.positionInfo'),
        expanded: true,
        labelWidth: '30px',
        children: [
          {
            type: 'inline',
            labelWidth: '30px',
            children: [
              {
                as: 'number',
                label: t('propsEditor.angle'),
                placeholder: t('propsEditor.angle'),
                name: 'angle',
                min: -360,
                formatter: value => `${value}°`,
                parser: value => value.replace('°', ''),
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
            ],
          },
          {
            type: 'inline',
            labelWidth: '30px',
            children: [
              {
                as: 'number',
                label: t('propsEditor.width'),
                placeholder: t('propsEditor.width'),
                name: 'width',
                min: 0,
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
              {
                as: 'number',
                label: t('propsEditor.height'),
                placeholder: t('propsEditor.height'),
                name: 'height',
                min: 0,
                disabled: true,
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
            ],
          },
          {
            type: 'inline',
            labelWidth: '30px',
            children: [
              {
                as: 'number',
                label: t('propsEditor.horizontal'),
                placeholder: t('propsEditor.horizontal'),
                name: 'left',
                formatter: formatterPx,
                min: 0,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
              {
                as: 'number',
                label: t('propsEditor.vertical'),
                placeholder: t('propsEditor.vertical'),
                name: 'top',
                min: 0,
                formatter: formatterPx,
                parser: parsePx,
                compStyle: { width: '72px' },
                style: { width: '120px' },
              },
            ],
          },
        ],
      },
      // {
      //   type: 'group',
      //   label: '排列',
      //   expanded: true,
      //   children: [],
      // },
    ],
  };
};
